var AccessSettingsV1 = /* @__PURE__ */ ((AccessSettingsV12) => {
  AccessSettingsV12[AccessSettingsV12["NONE"] = 1] = "NONE";
  AccessSettingsV12[AccessSettingsV12["DRAWING"] = 2] = "DRAWING";
  AccessSettingsV12[AccessSettingsV12["COLORING"] = 3] = "COLORING";
  AccessSettingsV12[AccessSettingsV12["ALL"] = 4] = "ALL";
  return AccessSettingsV12;
})(AccessSettingsV1 || {});
var PresetSettingsV1 = /* @__PURE__ */ ((PresetSettingsV12) => {
  PresetSettingsV12["NONE"] = "1";
  PresetSettingsV12["DRAWING_AUTO_ENABLED"] = "2";
  PresetSettingsV12["COLORING_AUTO_ENABLED"] = "3";
  return PresetSettingsV12;
})(PresetSettingsV1 || {});
var SpeechLanguageV1 = /* @__PURE__ */ ((SpeechLanguageV12) => {
  SpeechLanguageV12["DANISH"] = "mette22k";
  SpeechLanguageV12["ENGLISH"] = "lucy22k";
  SpeechLanguageV12["FRENCH"] = "alice22k";
  SpeechLanguageV12["GERMAN"] = "claudia22k";
  SpeechLanguageV12["SPANISH"] = "maria22k";
  return SpeechLanguageV12;
})(SpeechLanguageV1 || {});
var ScaleLogicV1 = /* @__PURE__ */ ((ScaleLogicV12) => {
  ScaleLogicV12["HORIZONTAL"] = "horizontal";
  ScaleLogicV12["VERTICAL"] = "vertical";
  ScaleLogicV12["BEST_FIT"] = "best-fit";
  return ScaleLogicV12;
})(ScaleLogicV1 || {});

export { AccessSettingsV1, PresetSettingsV1, ScaleLogicV1, SpeechLanguageV1 };
//# sourceMappingURL=ComponentDataV1.js.map
